import React from 'react';
import PropTypes from 'prop-types';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Hidden from '@material-ui/core/Hidden';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Button from "components/CustomButtons/Button";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Loading from 'components/Selfcare/Common/Loading';

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import 'react-circular-progressbar/dist/styles.css';
import { textAlign } from '@material-ui/system';

class Data extends React.Component {

    render() {
        const { subscription, classes, navigateTo, t } = this.props;
        const usedPercent = subscription && subscription.DataPot && subscription.DataPot.UsedPercent ? subscription.DataPot.UsedPercent : 0;
        const dataUsed = subscription && subscription.DataPot && subscription.DataPot.UsedData ? subscription.DataPot.UsedData : '';
        const dataTotal = subscription && subscription.DataPot && subscription.DataPot.TotalData ? subscription.DataPot.TotalData : "";
        return (
            <GridContainer direction="row" justify="center" alignItems="center">
                <Hidden smDown><GridItem md={3}>
                    <div style={{ width: '100%', textAlign: 'left', paddingLeft: '100px' }}>
                        <div>
                            <div style={{ color: '#e91e63', fontSize: '20px', paddingRight: '20px' }}>{subscription.Priceplan.Name}</div><br />
                            <div style={{ color: '#e91e63', fontSize: '0.875rem', paddingRight: '20px' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.contact-person-with-number', { 0: subscription.ContactPerson, 1: subscription.ContactNumber }) }} /></div>
                        </div>
                    </div>
                </GridItem></Hidden>
                <GridItem>
                    <div className={classes.content}>
                        <Hidden mdUp>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <div style={{ color: '#e91e63', fontSize: '20px'}}>{subscription.Priceplan.Name}</div><br />
                                <div style={{ color: '#e91e63', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.contact-person-with-number', { 0: subscription.ContactPerson, 1: subscription.ContactNumber }) }} /></div>
                            </div>
                        </Hidden>
                        {subscription && subscription.HasDataPot && subscription.DataPot.PotError === '' && !subscription.LoadingUsage ?
                            (
                                <div style={{ position: 'relative' }}>
                                    <GridContainer justify="center">
                                        <GridItem>
                                            <div style={{ paddingTop: '10px', paddingBottom: '20px', width: '280px', paddingRight: '5px' }}>
                                                <CircularProgressbarWithChildren className='data-usage'
                                                    value={usedPercent}
                                                    styles={buildStyles({
                                                        strokeLinecap: 'round',
                                                        textSize: '16px',
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#ff2680',
                                                        textColor: '#f88',
                                                        trailColor: '#d6d6d6',
                                                        backgroundColor: '#d6d6d6',
                                                    })}
                                                >
                                                <div style={{ fontSize: '12px', color: '#919191', textAlign: 'center', fontWeight: '700' }} >
                                                    <GridContainer justify="space-around">
                                                        <GridItem>
                                                                <div style={{ fontSize: '16px' }}>{t('selfcare:phrase.data-used')}:</div>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                                    <div style={{ fontSize: '12px', color: '#ff2680', textAlign: 'center', fontWeight: '700' }} >
                                                    <GridContainer justify="space-around">
                                                        <GridItem>
                                                            <div style={{ fontSize: '36px' }}>{dataUsed}</div>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#919191', textAlign: 'center', fontWeight: '700' }} >
                                                    <GridContainer justify="space-around">
                                                        <GridItem>
                                                                <div style={{ fontSize: '16px' }}>{t('selfcare:phrase.of-lc')} {dataTotal}</div>
                                                            <div style={{ fontSize: '12px' }}>{subscription.DataPot.DataRenewalDescription}</div>
                                                        </GridItem>
                                                    </GridContainer>
                                                    </div>
                                                </CircularProgressbarWithChildren>
                                                {subscription.DataPot.HasRollOver ?
                                                    <div>
                                                        <div style={{ fontSize: '13px', color: '#919191', textAlign: 'center', fontWeight: '700' }}>{subscription.DataPot.RollOverDescription}</div>
                                                    </div>
                                                    : null}
                                                {subscription.DataPot.HasTopUp ?
                                                    <div>
                                                        <div style={{ fontSize: '13px', color: '#919191', textAlign: 'center', fontWeight: '700' }}>{subscription.DataPot.TopUpDescription}</div>
                                                    </div>
                                                    : null}
                                                {subscription.DataPot.CanTopUp ?
                                                    (
                                                        <div style={{ textAlign: "center" }}>
                                                            <Button color="rose" style={{ borderRadius: "19px" }} onClick={() => navigateTo('/add-subscription-quota')}>{t('selfcare:button.purchase-more-data')}</Button>
                                                        </div>
                                                    ) : null}
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </div>
                            ) : ''}
                        {subscription && subscription.LoadingUsage ?
                            (
                                <GridContainer justify="center">
                                    <GridItem>
                                        <div style={{ paddingTop: '60px', paddingBottom: '20px', width: '280px', height: '317px', paddingRight: '5px' }}>
                                            <Loading message="" />
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            ) : ''}

                        {subscription && subscription.HasDataPot && subscription.DataPot.PotError !== '' ? <div style={{ fontSize: '16px', color: '#919191', textAlign: 'center', paddingTop: '20px', paddingBottom: '20px' }}>{t('selfcare:title.consumption')}: <div style={{ color: 'red' }}>{subscription.DataPot.PotError}</div></div> : null}
                        <Hidden mdUp>
                            {subscription && subscription.IsPostpaid ?
                                (<GridContainer justify="center" style={{ fontSize: '13px', paddingBottom: '10px' }}>
                                    <GridItem>
                                        <Typography variant="subtitle1" color="inherit" className={classes.flex}>
                                            <strong>{t('selfcare:title.including')}</strong>
                                        </Typography>
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <GridContainer className={classes.textCenter}>
                                            <GridItem xs={12}>
                                                <span dangerouslySetInnerHTML={{ __html: t('selfcare:item.data-used-in-country') }} /><br/>{subscription && subscription.Priceplan && subscription.Priceplan.DataTooltip ? <Tooltip placement="top" title={subscription.Priceplan.DataTooltip}><div>{subscription.Priceplan.DataSize}</div></Tooltip> : subscription.Priceplan.DataSize}
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>) : ''}
                        </Hidden>
                    </div>
                </GridItem>
                {subscription && subscription.IsPostpaid ?
                    (<Hidden smDown>
                        <GridItem md={3}
                        >
                            <Table style={{ marginLeft: '20px', width: '100%', maxWidth: '300px' }}>
                                <TableBody style={{ color: '#d81b60' }}>
                                    <TableRow style={{ height: '36px' }}>
                                        <TableCell colSpan="2" padding="none" style={{ color: '#d81b60' }}>
                                            <Typography variant="subtitle1" color="inherit" className={classes.flex}>
                                                <strong>{t('selfcare:title.including')}</strong>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow style={{ height: '36px' }}>
                                        <TableCell padding="none" style={{ color: '#d81b60' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:item.data-used-in-country') }} /></TableCell>
                                        <TableCell padding="none" style={{ color: '#d81b60' }}>{subscription && subscription.Priceplan && subscription.Priceplan.DataTooltip ? <Tooltip placement="top" title={subscription.Priceplan.DataTooltip}><div>{subscription.Priceplan.DataSize}</div></Tooltip> : subscription.Priceplan.DataSize}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </GridItem>
                    </Hidden>) : ''}
            </GridContainer>

        );
    }
}

Data.propTypes = {
    navigateTo: PropTypes.func.isRequired,
    subscription: PropTypes.object.isRequired,
};

export default compose(
    withTranslation(),
)(Data);
